<template>
  <div style="display: inline-block;">
    <button
      v-b-tooltip.hover
      variant="none"
      title="Visualizar guias do parcelamento"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
      :disabled="disableBySituacaoEParcela"
      @click="abrirGuiaGrid(gridProps.row)"
    >
      <font-awesome-icon
        icon="fa-solid fa-barcode"
        :class="gridProps.row.ultimaParcelaPaga || disableBySituacaoEParcela ? 'text-primary' : 'text-warning'"
      />
    </button>

    <b-btn
      v-b-tooltip.hover
      title="Observação"
      variant="none"
      class="btn-none rounded-pill m-0 icone-acao p-0"
      @click="openModalObservacao(gridProps.row)"
    >
      <font-awesome-icon
        icon="fa-regular fa-message"
        :class="{
          'text-success': todasObservacoesLidas,
          'text-warning': !todasObservacoesLidas && temObservacaoNova,
          'text-primary': !todasObservacoesLidas && !temObservacaoNova
        }"
      />
    </b-btn>
    <modal-whatsapp
      :tipo-rotina="tipoParcelamento"
      :row="gridProps.row"
      :api="apiParcela"
    />

    <button
      v-b-tooltip.hover
      variant="none"
      title="Enviar por e-mail"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
      :disabled="disableBySituacaoEParcela"
      @click="openEnvioEmail(gridProps.row)"
    >
      <feather-icon
        icon="SendIcon"
        class="text-primary"
        size="20"
      />
    </button>
    <button
      v-b-tooltip.hover
      variant="none"
      title="Parcelas"
      :disabled="gridProps.row.mesUltimaParcela == '-'"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
      @click="openModalParcelas(gridProps.row.id, gridProps.row.nroUltimaParcelaDe)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        :class="gridProps.row.parcelasEmAtraso ? 'text-danger' : gridProps.row.ultimaParcelaPaga ? 'text-success' :'text-primary'"
      />
    </button>

    <envio-email
      :ref="`modalEnvioEmail${gridProps.row.id}`"
      :title="`Enviar ${tipoParcelamento == 'nao-previdenciario' ? 'Não Previdenciário' : tipoParcelamento.toUpperCase()} por email ${gridProps.row.razaoSocial}`"
      :sugestao="gridProps.row.emailEmpresa"
      :sugestao-email-adicional="gridProps.row.emailAdicionalEmpresa"
      @enviarEmail="enviarEmail($event)"
    />

    <parcelas
      :ref="`modalParcelas${gridProps.row.id}`"
      title="Parcelas"
      :parcelamento="gridProps.row"
      :request-parcelas="requestParcelas"
      :tipo-parcelamento="tipoParcelamento"
      @envioEmail="openEnvioEmail($event)"
      @envioWhatsapp="openEnvioWhatsapp($event)"
      @mostrarGuia="abrirGuiaModal($event)"
      @openObservacoes="openModalObservacaoParcela($event, gridProps.row)"
      @loading="isLoading = $event"
    />

    <parcelas-recentes
      :ref="`modalParcelasRecentes${gridProps.row.id}`"
      title="Parcelas"
      :parcelamento="gridProps.row"
      :request-parcelas="requestParcelasRecentes"
      :tipo-parcelamento="tipoParcelamento"
      @envioEmail="openEnvioEmail($event)"
      @mostrarGuia="abrirGuiaModal($event)"
    />

    <visualizar-arquivo
      v-if="mostrarArquivo && urlArquivo"
      :url="urlArquivo"
      @hidden="fecharArquivo()"
    />

    <modal-observacao
      :ref="`modalObservacao${gridProps.row.id}`"
      v-model="docSelecionado"
      :tipo="tipoParcelamento"
      :api="apiObservacao"
      :notificar="{ sucesso: notficarSucesso, erro: notificarErro }"
      @hidden="fecharObservacao($event)"
    />

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Buscando'"
    />
  </div>
</template>

<style lang="scss" scoped>
.acoes-usuario {
  margin-right: 0.3rem;
  padding: 0.4rem;
}
.botoes-acao {
  padding: 0.5rem;
  padding-top: 0;
  padding-bottom: 0;
}
</style>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiParcela from '@/app/parcelamentos/shared/components/parcelas/services/api'
import Vue from 'vue'

export default {
  components: {
    ModalWhatsapp: () => import('@/app/shared/components/whatsapp/ModalWhatsapp.vue'),
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    Parcelas: () => import('../parcelas/Parcelas.vue'),
    ParcelasRecentes: () => import('../parcelas-recentes/ParcelasRecentes.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
    requestEnviarEmail: {
      type: Function,
      required: true,
    },
    requestParcelas: {
      type: Function,
      required: true,
    },
    requestParcelasRecentes: {
      type: Function,
      required: true,
    },
    requestGuiaParcelamento: {
      type: Function,
      required: true,
    },
    tipoParcelamento: {
      type: String,
      default: '',
    },
    api: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarArquivo: false,
      urlArquivo: '',
      currParcelaId: 0,
      isLoading: false,
      docSelecionado: this.gridProps.row,
      apiObservacao: this.api,
      apiParcela: this.api,
    }
  },
  computed: {
    disableBySituacaoEParcela() {
      return this.gridProps.row.situacao !== 'Em parcelamento' || this.gridProps.row.mesUltimaParcela === '-'
    },
    temObservacaoNova() {
      return this.gridProps?.row?.temObservacoesNaoLidas ?? false
    },
    todasObservacoesLidas() {
      return this.gridProps?.row?.todasObservacoesLidas ?? false
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    enviarEmail(itens) {
      if (itens.emailsPara.length < 1 && itens.emailsCc < 1) {
        this.notificarErro('Informe ao menos um e-mail')
      } else {
        const parcelamentoId = this.gridProps.row.id
        if (this.currParcelaId) {
          this.$refs[`modalParcelas${this.gridProps.row.id}`].iniciarEspera()
        }

        this.requestEnviarEmail(this.gridProps.row.razaoSocial, itens.emailsPara, itens.emailsCc, parcelamentoId, this.currParcelaId, itens.mensagensAdicional, itens.definirEmailPadroes)
          .then(payload => {
            this.urlArquivo = payload.data
            this.mostrarArquivo = true
            this.$sucesso('E-mail enviado', 'success')
          })
          .catch(err => {
            if (err.response.data.message.includes('Erro ao enviar email')) {
              this.notificarErro('Não foi possível enviar o email. Verifique as configurações de SMTP e tente novamente.')
            } else if (err.response.data.message.includes('Guia indisponível.')) {
              this.notificarErro('Não foi possível enviar o email. Guia indisponível no momento, tente novamente mais tarde.')
            } else {
              this.notificarErro('Ocorreu um erro interno, favor entrar em contato com o suporte.')
            }

            throw err
          })
          .finally(() => {
            this.isLoading = false
          })
        this.currParcelaId = 0
      }
    },
    abrirGuiaGrid(parcelamento) {
      this.$refs[`modalParcelasRecentes${parcelamento.id}`].show()
    },
    abrirGuiaModal(parcelamento) {
      this.isLoading = true
      this.requestGuiaParcelamento(parcelamento.id, parcelamento.parcelaId)
        .then(payload => {
          this.urlArquivo = payload.data
          this.mostrarArquivo = true
          this.$refs[`modalParcelas${parcelamento.id}`].carregarParcelas()
        })
        .catch(err => {
          this.fecharArquivo()
          this.notificarErro(err.response.data.message)
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fecharArquivo() {
      this.mostrarArquivo = false
      this.urlArquivo = ''
    },
    openEnvioEmail(parcelamento) {
      if (parcelamento.nroUltimaParcelaDe && parcelamento.nroUltimaParcelaDe.includes('-')) {
        Vue.swal({
          title: 'Não há documento para o envio!',
          text: 'Não foram encontradas parcelas em aberto para o contribuinte.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn btn-outline-primary mr-50',
          },
          buttonsStyling: false,
        })
      } else {
        if (parcelamento.parcelaId) {
          this.currParcelaId = parcelamento.parcelaId
        }
        this.$refs[`modalEnvioEmail${parcelamento.id}`].$refs.modalEnviarEmail.show()
      }
    },
    openEnvioWhatsapp(parcelamento) {
      if (parcelamento.nroUltimaParcelaDe && parcelamento.nroUltimaParcelaDe.includes('-')) {
        Vue.swal({
          title: 'Não há documento para o envio!',
          text: 'Não foram encontradas parcelas em aberto para o contribuinte.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn btn-outline-primary mr-50',
          },
          buttonsStyling: false,
        })
      } else {
        const rowWhatsapp = {
          id: parcelamento.id,
          parcelaId: parcelamento.parcelaId,
          razaoSocial: this.gridProps.row.razaoSocial,
        }

        import('@/app/parcelamentos/shared/components/parcelas/services/api').then(module => {
          const apiParcelas = module.default(this.tipoParcelamento)

          apiParcelas.getDocWhatsapp(parcelamento.id, parcelamento.parcelaId)
            .then(payload => {
              this.mostrarModalWhatsapp(payload.data, rowWhatsapp)
            })
            .catch(err => {
              this.notificarErro(`Erro ao buscar documento para WhatsApp: ${err.message}`)
            })
        })
      }
    },
    mostrarModalWhatsapp(linkArquivo, row) {
      const tipoRotina = this.tipoParcelamento === 'pert' || this.tipoParcelamento === 'relp'
        ? `${this.tipoParcelamento.toUpperCase()}-SN`
        : this.tipoParcelamento.toUpperCase().replace('_', ' ')

      const mensagem = `Olá ${row.razaoSocial} segue link para download da ${tipoRotina}.\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\n`

      this.$swal({
        width: 680,
        title: '<div class="text-secondary mb-2  mt-1">Envio via WhatsApp</div>',
        html: `
          <textarea readonly class="form-control" rows="6" columns="6">${mensagem} 
          </textarea>
          <div class="text-primary mb-1 mt-1">
            <a href="${linkArquivo}" target="_blank" class="text-secondary" style="text-decoration: underline;">Link do arquivo</a>
          </div>
        `,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'WhatsApp',
        denyButtonText: 'Copiar link',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          denyButton: 'btn btn-outline-secondary mr-50',
          cancelButton: 'btn btn-outline-danger mr-50',
        },
        allowOutsideClick: true,
      }).then(result => {
        if (result.isConfirmed) {
          const url = `https://wa.me/?text=${encodeURIComponent(`${mensagem}${linkArquivo}`)}`
          window.open(url)
        } else if (result.isDenied) {
          this.$swal('Copiado!', '', 'success')
          navigator.clipboard.writeText(linkArquivo)
        }
      })
    },
    openModalParcelas(id, nroUltimaParcelaDe) {
      if (nroUltimaParcelaDe.includes('-')) {
        Vue.swal({
          title: 'Não há guia para impressão!',
          text: 'Não foram encontradas parcelas em aberto para o contribuinte.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn btn-outline-primary mr-50',
          },
          buttonsStyling: false,
        })
      } else {
        this.$refs[`modalParcelas${id}`].show()
      }
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
    },
    openModalObservacao(documento) {
      this.docSelecionado = documento
      this.$nextTick(() => {
        this.$refs[`modalObservacao${this.gridProps.row.id}`].show()
      })
    },
    openModalObservacaoParcela(documento) {
      this.$refs[`modalParcelas${this.gridProps.row.id}`].hide()
      this.apiObservacao = apiParcela(this.tipoParcelamento)
      const document = documento
      document.title = `Parcela ${documento.tributo} ${documento.numeroParcela} - ${this.gridProps.row.razaoSocial}`
      this.openModalObservacao(document)
    },
    fecharObservacao(observacao) {
      if (observacao.value && observacao.value.numeroParcela) {
        const index = this.$refs[`modalParcelas${this.gridProps.row.id}`].parcelas.findIndex(where => where.id === observacao.value.id)
        this.$refs[`modalParcelas${this.gridProps.row.id}`].parcelas[index].temObservacoesNaoLidas = observacao.hasObservacaoNova
      } else {
        this.gridProps.row.temObservacoesNaoLidas = observacao.hasObservacaoNova
        this.gridProps.row.todasObservacoesLidas = observacao.observacaoLida
      }
      this.$set(this.docSelecionado, null)
      this.gridProps.row.observacao = ''
      this.apiObservacao = this.api
      this.$refs[`modalParcelas${this.gridProps.row.id}`].stacking = true
    },
  },
}
</script>
